export default __webpack_public_path__ + "static/media/ClipboardReport.1d50bcbc.svg";